import React, {useState} from "react";
import {
    Box,
    Button,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel, MenuItem,
    OutlinedInput,
    Select,
    TextField,
    Typography
} from "@mui/material";
import Logo from "../../../../picture/Logo.png";
import styled from "styled-components";
import { updateOne } from "../../../../api";
import moment from "moment-timezone";

const FormHelperTextsRED = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
  display: flex;
  align-items: center;
`;

const FormHelperTextsBLUE = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #0f27d9 !important;
`;

export default function InfoUpdateModalComponent(props){

    const { data,sizeType }=props


    let userInfo = {
        name:data.map(e=>e.name)[0],
        userId:data.map(e=>e.id)[0],
        birth:data.map(e=>e.birth)[0],
        phone:data.map(e=>e.phone)[0],
        admin:data.map(e=>e.admin)[0],
        start_up:data.map(e=>e.start_up)[0]
    }

    const checkList = ['O','X']

    const [name, setName] = useState('')
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [admin, setAdmin] = useState('')
    const [startUp, setStartUp] = useState('')



    const [NameMessage, setNameMessage] = useState('')
    const [EmailMessage, setEmailMessage] = useState("")
    const [PwMessage, setPwMessage] = useState("")
    const [PhoneMessage, setPhoneMessage] = useState("")


    const now = new Date();
    const open = moment().tz('Asia/Seoul')
    const formYear = open.format(`YYYY`)

    const [form, setForm] = useState({
        year: userInfo.birth.split('-')[0],
        month: userInfo.birth.split('-')[1],
        day: userInfo.birth.split('-')[2],
    });


    let years = [];
    for (let y = now.getFullYear(); y >= 1900; y -= 1) {
        years.push(y);
    }

    let month = [];
    for (let m = 1; m <= 12; m += 1) {
        if (m < 10) {
            // 날짜가 2자리로 나타나야 했기 때문에 1자리 월에 0을 붙혀준다
            month.push("0" + m.toString());
        } else {
            month.push(m.toString());
        }
    }
    let days = [];
    let date = new Date(form.year, form.month, 0).getDate();
    for (let d = 1; d <= date; d += 1) {
        if (d < 10) {
            // 날짜가 2자리로 나타나야 했기 때문에 1자리 일에 0을 붙혀준다
            days.push("0" + d.toString());
        } else {
            days.push(d.toString());
        }
    }


    const onChangeName = (e) => {
        const currentName = e.currentTarget.value;
        setName(currentName)
        const nameRegExp = /^[가-힣a-zA-Z]+$/;

        if (!nameRegExp.test(currentName) || name.length<1) {
            setNameMessage('이름을 두 글자 이상 입력하세요!');
        } else {
            setNameMessage('');
        }
    }

    const onChangeEmail = (e) => {
        const currentEmail = e.currentTarget.value;
        setUserId(currentEmail)
        const emailRegExp =
            /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/;

        if (!emailRegExp.test(currentEmail)) {
            setEmailMessage("이메일의 형식이 올바르지 않습니다!");
        } else {
            setEmailMessage("");
        }
    };

    const onChangePassword = (e) => {
        const currentPw = e.currentTarget.value;
        setPassword(currentPw);
        const passwordRegExp =
            /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
        if (!passwordRegExp.test(currentPw)) {
            setPwMessage(
                "숫자+영문자+특수문자 조합으로 8자리 이상 입력해주세요!"
            );
        } else {
            setPwMessage("");
        }
    };


    const onChangePhone = (getNumber) => {
        const currentPhone = getNumber;
        setPhone(currentPhone);
        const phoneRegExp = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;

        if (!phoneRegExp.test(currentPhone)) {
            setPhoneMessage('올바른 핸드폰번호를 입력해주세요. (" - " <= 하이픈 필수입니다.)');
        } else {
            setPhoneMessage("");
        }
    };

    const addHyphen = (e) => {
        const currentNumber = e.currentTarget.value;
        setPhone(currentNumber);
        if (currentNumber.length === 3 || currentNumber.length === 8) {
            setPhone(currentNumber + "-");
            onChangePhone(currentNumber + "-");
        } else {
            onChangePhone(currentNumber);
        }
    };
    const onAdmin = (e)=>{
        setAdmin(e.target.value)
    }

    const onStartUp = (e)=>{
        setStartUp(e.target.value)
    }


    const onUpdate = (e) =>{
        e.preventDefault()
        let sendData ={
            name:name === '' ? userInfo.name : name,
            birth: `${form.year}-${form.month}-${form.day}`,
            userId:userId === '' ? userInfo.userId : userId,
            password:password === '' ? 'PlanePassword':password,
            phone:phone === '' ? userInfo.phone : phone,
            admin:admin === '' ? userInfo.admin : admin,
            start_up:startUp === '' ? userInfo.start_up : startUp
        }
        updateOne(sendData)
            .then(res=>{
                alert(`업데이트 성공`)
                window.location.replace('/adminPage')
            })
            .catch(e=>{
                console.log(e)
            })


    }



    return(
        <>
            {sizeType ==="mobile" ? (
                <>
                    <div style={{height: 350, width: '100%'}}>
                        <Box
                            component="form"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                backgroundColor: 'white',
                                borderRadius: '1rem',
                            }}
                        >
                            <img alt="No Images" src={Logo} style={{width:150}}/><br/>

                            <Typography component="h4" variant="h0">
                                단일 정보수정
                            </Typography><br/>
                            <Grid container spacing={1}>
                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        onChange={onChangeName}
                                        autoFocus
                                        required
                                        size="small"
                                        fullWidth
                                        type="text"
                                        name="name"
                                        label='이름'
                                        defaultValue={userInfo.name}
                                    /><br/>
                                </Grid>
                                <br/>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <FormHelperTextsRED>{NameMessage}</FormHelperTextsRED>
                                </Grid>
                                <Grid item xs={1}/>


                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <div style={{paddingLeft:4}}>
                                        <FormControl sx={{marginTop: 0.1, minWidth: 70,paddingRight:1}} variant="standard">
                                            <InputLabel id="demo-simple-select-label">생년</InputLabel>
                                            <Select
                                                value={form.year}
                                                onChange={(e)=>
                                                    setForm({ ...form, year:e.target.value})}
                                                labelId="demo-simple-select-label"
                                                autoWidth
                                                sx={{height: '31px', width: '70px'}}
                                            >
                                                <MenuItem value="">
                                                    <em>생년</em>
                                                </MenuItem>
                                                {years.map((item) => (
                                                    <MenuItem
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <FormControl sx={{marginTop: 0.1, minWidth: 70,paddingRight:1}} variant="standard">
                                            <InputLabel id="demo-simple-select-label">월</InputLabel>
                                            <Select
                                                value={form.month}
                                                onChange={(e)=>
                                                    setForm({ ...form, month:e.target.value})}
                                                labelId="demo-simple-select-label"
                                                autoWidth
                                                sx={{height: '31px', width: '70px'}}
                                            >
                                                <MenuItem value="">
                                                    <em>월</em>
                                                </MenuItem>
                                                {month.map((item) => (
                                                    <MenuItem
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <FormControl sx={{marginTop: 0.1, minWidth: 100}} variant="standard">
                                            <InputLabel id="demo-simple-select-label">일</InputLabel>
                                            <Select
                                                value={form.day}
                                                onChange={(e)=>{
                                                    setForm({ ...form, day:e.target.value})
                                                }}
                                                labelId="demo-simple-select-label"
                                                autoWidth
                                                sx={{height: '31px', width: '70px'}}
                                            >
                                                <MenuItem value="">
                                                    <em>일</em>
                                                </MenuItem>
                                                {days.map((item) => (
                                                    <MenuItem
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                                <br/>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                </Grid>
                                <Grid item xs={1}/>


                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        onChange={onChangeEmail}
                                        required
                                        size="small"
                                        fullWidth
                                        type="text"
                                        name="userId"
                                        label='아이디'
                                        defaultValue={userInfo.userId}
                                    /><br/>
                                </Grid>
                                <br/>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <FormHelperTextsRED>{EmailMessage}</FormHelperTextsRED>
                                </Grid>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        onChange={onChangePassword}
                                        required
                                        fullWidth
                                        defaultValue="******"
                                        size="small"
                                        type="password"
                                        name="password"
                                        label="비밀번호 (숫자+영문자+특수문자 8자리 이상)"
                                        error={PwMessage === '숫자+영문자+특수문자 조합으로 8자리 이상 입력해주세요!'}
                                    />
                                </Grid>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <FormHelperTextsRED>{PwMessage}</FormHelperTextsRED>
                                </Grid>
                                <Grid item xs={1}/>


                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        onChange={addHyphen}
                                        required
                                        fullWidth
                                        size="small"
                                        type="text"
                                        name="phone"
                                        label='전화번호'
                                        defaultValue={userInfo.phone}
                                    /><br/>
                                </Grid>
                                <br/>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <FormHelperTextsRED>{PhoneMessage}</FormHelperTextsRED>
                                </Grid>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={5}>
                                    <FormControl fullWidth >
                                        <InputLabel>관리자</InputLabel>
                                        <Select
                                            onChange={onAdmin}
                                            defaultValue={userInfo.admin}
                                            rowsPerPageOptions
                                            size="small"
                                            name="admin"
                                            type='text'
                                            input={<OutlinedInput label="name" />}
                                        >
                                            {checkList.map((item) => (
                                                <MenuItem
                                                    key={item}
                                                    value={item}
                                                >
                                                    {item}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={5}>
                                    <FormControl fullWidth >
                                        <InputLabel>개통여부</InputLabel>
                                        <Select
                                            onChange={onStartUp}
                                            defaultValue={userInfo.start_up}
                                            rowsPerPageOptions
                                            size="small"
                                            name="startUp"
                                            type='text'
                                            input={<OutlinedInput label="name" />}
                                        >
                                            {checkList.map((item) => (
                                                <MenuItem
                                                    key={item}
                                                    value={item}
                                                >
                                                    {item}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <br/>

                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <Button
                                        onClick={onUpdate}
                                        variant="contained"
                                        type="submit"
                                        size="medium"
                                        fullWidth
                                        sx={{
                                            marginTop: 1,
                                            height: '45px',
                                            border: 3,
                                            "&.MuiButton-root:hover": {
                                                color: '#008DDC',
                                                backgroundColor: '#c7ebff',
                                                borderColor: '#008DDC'
                                            }
                                        }}

                                    >
                                        수정하기
                                    </Button>
                                </Grid>
                            </Grid>

                        </Box>
                    </div>
                </>
            ):(
                <>
                    <div style={{height: 600, width: '100%'}}>
                        <Box
                            component="form"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                backgroundColor: 'white',
                                height: '550px',
                                width: '530px',
                                borderRadius: '1rem',
                            }}
                        >
                            <img alt="No Images" src={Logo} style={{width:200}}/><br/>

                            <Typography component="h4" variant="h0">
                                단일 정보수정
                            </Typography><br/>
                            <Grid container spacing={1}>
                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        onChange={onChangeName}
                                        autoFocus
                                        required
                                        fullWidth
                                        type="text"
                                        name="name"
                                        label='이름'
                                        defaultValue={userInfo.name}
                                    /><br/>
                                </Grid>
                                <br/>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <FormHelperTextsRED>{NameMessage}</FormHelperTextsRED>
                                </Grid>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <div style={{paddingLeft:10}}>
                                        <FormControl sx={{marginTop: 0.1, minWidth: 70,paddingRight:5}} variant="standard">
                                            <InputLabel id="demo-simple-select-label">생년</InputLabel>
                                            <Select
                                                value={form.year}
                                                onChange={(e)=>
                                                    setForm({ ...form, year:e.target.value})}
                                                labelId="demo-simple-select-label"
                                                autoWidth
                                                sx={{height: '31px', width: '80px'}}
                                            >
                                                <MenuItem value="">
                                                    <em>생년</em>
                                                </MenuItem>
                                                {years.map((item) => (
                                                    <MenuItem
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <FormControl sx={{marginTop: 0.1, minWidth: 70,paddingRight:5}} variant="standard">
                                            <InputLabel id="demo-simple-select-label">월</InputLabel>
                                            <Select
                                                value={form.month}
                                                onChange={(e)=>
                                                    setForm({ ...form, month:e.target.value})}
                                                labelId="demo-simple-select-label"
                                                autoWidth
                                                sx={{height: '31px', width: '80px'}}
                                            >
                                                <MenuItem value="">
                                                    <em>월</em>
                                                </MenuItem>
                                                {month.map((item) => (
                                                    <MenuItem
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <FormControl sx={{marginTop: 0.1, minWidth: 100}} variant="standard">
                                            <InputLabel id="demo-simple-select-label">일</InputLabel>
                                            <Select
                                                value={form.day}
                                                onChange={(e)=>{
                                                    setForm({ ...form, day:e.target.value})
                                                }}
                                                labelId="demo-simple-select-label"
                                                autoWidth
                                                sx={{height: '31px', width: '80px'}}
                                            >
                                                <MenuItem value="">
                                                    <em>일</em>
                                                </MenuItem>
                                                {days.map((item) => (
                                                    <MenuItem
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                                <br/>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                </Grid>
                                <Grid item xs={1}/><br/>


                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        onChange={onChangeEmail}
                                        required
                                        fullWidth
                                        type="text"
                                        name="userId"
                                        label='아이디'
                                        defaultValue={userInfo.userId}
                                    /><br/>
                                </Grid>
                                <br/>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <FormHelperTextsRED>{EmailMessage}</FormHelperTextsRED>
                                </Grid>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        onChange={onChangePassword}
                                        required
                                        fullWidth
                                        defaultValue="******"
                                        type="password"
                                        name="password"
                                        label="비밀번호 (숫자+영문자+특수문자 8자리 이상)"
                                        error={PwMessage === '숫자+영문자+특수문자 조합으로 8자리 이상 입력해주세요!'}
                                    />
                                </Grid>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <FormHelperTextsRED>{PwMessage}</FormHelperTextsRED>
                                </Grid>
                                <Grid item xs={1}/>


                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        onChange={addHyphen}
                                        required
                                        fullWidth
                                        type="text"
                                        name="phone"
                                        label='전화번호'
                                        defaultValue={userInfo.phone}
                                    /><br/>
                                </Grid>
                                <br/>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <FormHelperTextsRED>{PhoneMessage}</FormHelperTextsRED>
                                </Grid>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={5}>
                                    <FormControl fullWidth >
                                        <InputLabel>관리자</InputLabel>
                                        <Select
                                            onChange={onAdmin}
                                            defaultValue={userInfo.admin}
                                            rowsPerPageOptions
                                            name="admin"
                                            type='text'
                                            input={<OutlinedInput label="name" />}
                                        >
                                            {checkList.map((item) => (
                                                <MenuItem
                                                    key={item}
                                                    value={item}
                                                >
                                                    {item}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={5}>
                                    <FormControl fullWidth >
                                        <InputLabel>개통여부</InputLabel>
                                        <Select
                                            onChange={onStartUp}
                                            defaultValue={userInfo.start_up}
                                            rowsPerPageOptions
                                            name="startUp"
                                            type='text'
                                            input={<OutlinedInput label="name" />}
                                        >
                                            {checkList.map((item) => (
                                                <MenuItem
                                                    key={item}
                                                    value={item}
                                                >
                                                    {item}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <br/>

                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <Button
                                        onClick={onUpdate}
                                        variant="contained"
                                        type="submit"
                                        size="medium"
                                        fullWidth
                                        sx={{
                                            marginTop: 1,
                                            height: '45px',
                                            border: 3,
                                            "&.MuiButton-root:hover": {
                                                color: '#008DDC',
                                                backgroundColor: '#c7ebff',
                                                borderColor: '#008DDC'
                                            }
                                        }}

                                    >
                                        수정하기
                                    </Button>
                                </Grid>
                            </Grid>

                        </Box>
                    </div>
                </>
            )}


        </>
    )
}